/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Ai_Ready_Detail_NoteInputs */

const en_directory_detail_signals_ai_ready_detail_note = /** @type {(inputs: Directory_Detail_Signals_Ai_Ready_Detail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggregated from the Seek AI agent-readiness benchmark: six dimensions, twenty-one automated checks, mapped onto the four stages an agent actually fails in — discover, learn, operate, verify.`)
};

const zh_directory_detail_signals_ai_ready_detail_note = /** @type {(inputs: Directory_Detail_Signals_Ai_Ready_Detail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Seek AI agent-readiness 基准聚合而来：六个维度、二十一项自动化检查，映射到 Agent 真实失败的四个阶段——发现、学习、操作、验证。`)
};

/**
* | output |
* | --- |
* | "Aggregated from the Seek AI agent-readiness benchmark: six dimensions, twenty-one automated checks, mapped onto the four stages an agent actually fails in — ..." |
*
* @param {Directory_Detail_Signals_Ai_Ready_Detail_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_ai_ready_detail_note = /** @type {((inputs?: Directory_Detail_Signals_Ai_Ready_Detail_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Ai_Ready_Detail_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_ai_ready_detail_note(inputs)
	return zh_directory_detail_signals_ai_ready_detail_note(inputs)
});
export { directory_detail_signals_ai_ready_detail_note as "directory.detail.signals.ai_ready_detail_note" }